import SimpleBar from 'simplebar-react';
// @mui
import { styled } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export const StyledRootScrollbar = styled('div')(() => ({
  flexGrow: 1,
  height: '100%',
  overflowX: 'hidden',
  position: 'relative'
}));

export const StyledScrollbar = styled(SimpleBar)(({ theme }) => ({
  minHeight: '100%',
  overflowY: 'scroll',
  position: 'absolute',
  right: '-17px',
  left: 0,
  '& .simplebar-scrollbar': {
    '&:before': {
      backgroundColor: alpha(theme.palette.grey[600], 0.48),
    },
    '&.simplebar-visible:before': {
      opacity: 1,
    },
  },
  '& .simplebar-track.simplebar-vertical': {
    width: 10,
  },
  '& .simplebar-track.simplebar-horizontal .simplebar-scrollbar': {
    height: 6,
  },
  '& .simplebar-mask': {
    zIndex: 'inherit',
  },
}));
